export function getColumns(state) {
	return state.getIn(["search", "columns"]);
}
